import { useContext } from 'react';
import type { FeatureName } from '../../types';
import { FeatureSecurityContext } from '../contexts/FeatureSecurityContext';

export function useFeatureSecurityChain(): FeatureName[] {
    const contextValue = useContext(FeatureSecurityContext);
    return contextValue?.featureNames ?? [];
}
